import type { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { clsx } from 'clsx';

import type { LcpnTheme } from '../../styles/theme';
import { Typography } from '../Typography';

const useStyles = createUseStyles((theme: LcpnTheme) => ({
  listHeading: {
    backgroundColor: theme.colors['grey-100'],
    paddingBlock: theme.spacing(4),
    paddingInlineStart: theme.spacing(3),
    paddingInlineEnd: theme.spacing(3),
  },

  textGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  link: {
    textDecoration: 'underline',
    textUnderlineOffset: 10,
    cursor: 'pointer',
  },

  [`@media screen and (max-width: ${theme.breakPoints.tablet}px)`]: {
    listHeading: {
      '&&': {
        padding: theme.spacing(2, 0),
      },
    },
  },
}));

type Props = {
  label?: string;
  navigationLabel?: string;
  navigationAction?: () => void;
  navigationVisible?: boolean;
  className?: string;
  actionElement?: ReactNode;
};

export function ListHeading(props: Props) {
  const classes = useStyles();
  const {
    navigationAction,
    navigationLabel,
    navigationVisible = true,
    label = '',
    className,
    actionElement,
  } = props;
  return (
    <div className={clsx(classes.listHeading, className)}>
      <div className={classes.textGroup}>
        <Typography variant="p2" fontWeight={400}>
          {label}
        </Typography>
        {navigationVisible &&
          (actionElement || (
            <button className={classes.link} onClick={navigationAction}>
              <Typography variant="p2" fontWeight={400}>
                {navigationLabel}
              </Typography>
            </button>
          ))}
      </div>
    </div>
  );
}
